// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { browserHistory} from 'react-router';

import * as HeaderActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/header';
import * as FooterActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/footer';
import PageTracker from 'app-lib/helpers/page-tracker';
import Page from 'src/model/page';

const classPrefix = 'error-page';
export class InternalServer extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {t} = this.props;
        PageTracker.lastPage = Page.INTERNAL_ERROR;
        this.setHeader();
        this.props.initFooter({
            isActive: true,
            classes: 'generic-page-footer',
            left: <span>{t('channel.footer.powered')}</span>,
            right: [
                <span id="terms&conditions" key="terms&conditions">
                    <a href={`${config.company.termsOfService}`} target="_blank" rel="noopener">
                       {t('channel.footer.tnc')}
                    </a>
                </span>,
                <span key="privacy">
                    <a href={`${config.company.privacyPolicy}`} target="_blank" rel="noopener">
                       {t('channel.footer.privacy')}
                    </a>
                </span>,
                <span key="rights">{t('channel.footer.copyright')} {t('channel.footer.company')}</span>
            ]
        });
    }


    componentWillUnmount() {
        this.props.initHeader();
        this.props.initFooter();
    }

    setHeader() {
        const self = this;
        self.props.initHeader({
            navbarBackgroundClasses: 'error-page-header-nav-bar',
            menuItemTextClasses: 'error-page-header-menu-item-text',
            showAlternateLogo: true
        });
    }

    render() {
        const {t} = this.props;
        return (
            <div className={`${classPrefix}-content-center`}>
                <img src={`${config.assets.url}/images/error/error_page_not_found.png`} alt="" />
                <div className="content-head">{t('internalServer.something')}</div>
                <div className="content-description">
                    <div>{t('internalServer.fix')}</div>
                    <button type="button" className="btn" onClick={browserHistory.goBack}>{t('internalServer.refresh')}</button>
                </div>
            </div>
        );
    }
}

InternalServer.propTypes = {
    t: PropTypes.func.isRequired,
    initHeader: PropTypes.func.isRequired,
    initFooter: PropTypes.func.isRequired
};

export default connect(
    null,
    dispatch => bindActionCreators(Object.assign({}, HeaderActions, FooterActions), dispatch)
)(translate(['translation'])(InternalServer));



// WEBPACK FOOTER //
// ./src/components/errors/internalServer.js